import { render, staticRenderFns } from "./rightPetition.vue?vue&type=template&id=78e018f0"
import script from "./rightPetition.vue?vue&type=script&lang=js"
export * from "./rightPetition.vue?vue&type=script&lang=js"
import style0 from "./rightPetition.vue?vue&type=style&index=0&id=78e018f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports